import React, { Component, useState, useMemo } from "react";

import DefaultDataGrid from '../components/DefaultDataGrid';
import { Stack } from '@mui/system';
import { Grid, TextField, Typography } from '@mui/material';
import AutocompleteText from "./AutocompleteText";
import InputColumn from './InputColumn'

export default function InputRow(props) {
    const dataReference = { "ref": props.data };
    const [data, setData] = useState(props.data);
    const setInputValue = (inputName, value) => {
        // console.log(data)
        // console.log(inputName, value)
        data[inputName] = value;
        dataReference['ref'][inputName] = value;
        setData({ ...data });
        // console.log(dataReference)
    };
    return (
        <Grid xs={12} container item columnSpacing={2} sx={Object.assign({ paddingLeft: "4px", margin: "0px", marginBottom: "20px", width: "auto" }, props.sx)} className={props.container === undefined || props.container == true ? "container" : undefined}>
            {Object.keys(props.inputColumns).map((k, index) => {
                return (<InputColumn title={k} fields={props.inputColumns[k]} key={props.inputColumns[k]} data={data} disabled={props.disabled}
                    setInputValue={setInputValue} useDatanameFirst={props.useDatanameFirst} />)
            })
            }
        </Grid>
    )
}